// Web mock for react-native-html-to-pdf
const RNHTMLtoPDF = {
  convert: async (options: {
    html: string;
    fileName?: string;
    base64?: boolean;
  }): Promise<{ filePath: string; base64?: string }> => {
    // On web, create a printable window
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      printWindow.document.write(options.html);
      printWindow.document.close();
      printWindow.print();
    }
    return { filePath: '' };
  },
};

export default RNHTMLtoPDF;
